/* K Town Distro — smoke & motion effects (Sep 28 2026)
   - Homepage: drifting smoke over the hero + order-form band, cursor "blows" smoke,
     hero heading condenses out of the vapour, vapour trail follows the mouse.
   - Site-wide: scroll reveals, gold progress bar, smoke puff on card hover,
     smoke burst + cart bounce on add-to-cart, button ripples.
   Canvas loops pause when off-screen / tab hidden. Respects reduced motion. */
(function () {
  'use strict';
  if (window.__ktdFx) return; window.__ktdFx = 1;
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var root = document.documentElement;
  var isHome = document.documentElement.dataset.ktdTemplate === 'index';
  var finePointer = matchMedia('(hover: hover) and (pointer: fine)').matches;
  var small = window.innerWidth < 750;
  var DPR = Math.min(window.devicePixelRatio || 1, small ? 1.25 : 1.5);
  var rand = function (a, b) { return a + Math.random() * (b - a); };

  /* ---------- Smoke sprites (soft puffs drawn once, reused) ---------- */
  // Wispy smoke texture: fractal value-noise, faded out toward the edges.
  function makeSprite(rgb) {
    var s = 128, c = document.createElement('canvas'); c.width = c.height = s;
    var x = c.getContext('2d'), img = x.createImageData(s, s), d = img.data;
    var G = 16, grid = [];
    for (var i = 0; i < (G + 1) * (G + 1) * 4; i++) grid.push(Math.random());
    function vn(px, py, f) { // smooth value noise sampled on a grid of size f
      var gx = px * f, gy = py * f, x0 = gx | 0, y0 = gy | 0, tx = gx - x0, ty = gy - y0, W = G + 1;
      tx = tx * tx * (3 - 2 * tx); ty = ty * ty * (3 - 2 * ty);
      var o = (f % 5) * W * W;
      var a = grid[o + y0 * W + x0], b = grid[o + y0 * W + x0 + 1], cc = grid[o + (y0 + 1) * W + x0], dd = grid[o + (y0 + 1) * W + x0 + 1];
      return a + (b - a) * tx + (cc - a) * ty + (a - b - cc + dd) * tx * ty;
    }
    var p = rgb.split(',').map(Number);
    for (var yy = 0; yy < s; yy++) for (var xx = 0; xx < s; xx++) {
      var u = xx / s, v = yy / s, dx = u - .5, dy = v - .5, r = Math.sqrt(dx * dx + dy * dy) * 2;
      var fall = Math.max(0, 1 - r); fall = fall * fall * (3 - 2 * fall);
      var n = vn(u, v, 3) * .5 + vn(u, v, 6) * .3 + vn(u, v, 12) * .2;
      var a = Math.max(0, n - .35) * 1.9 * fall;
      var k = (yy * s + xx) * 4; d[k] = p[0]; d[k + 1] = p[1]; d[k + 2] = p[2]; d[k + 3] = Math.min(255, a * 255);
    }
    x.putImageData(img, 0, 0);
    return c;
  }
  var SPR = [], SPR_GOLD, SPR_DARK = [];
  function sprites() {
    if (SPR.length) return;
    SPR = [makeSprite('235,235,240'), makeSprite('225,225,232'), makeSprite('245,242,235')];
    SPR_GOLD = makeSprite('232,200,120');
    SPR_DARK = [makeSprite('70,70,76'), makeSprite('95,92,88')];
  }
  // Is the section light? Then draw grey smoke instead of white.
  function isLight(el) {
    for (var n = el; n && n !== document.documentElement; n = n.firstElementChild || null) {
      var m = getComputedStyle(n).backgroundColor.match(/[\d.]+/g);
      if (m && (m.length < 4 || +m[3] > .5)) return (+m[0] * .299 + +m[1] * .587 + +m[2] * .114) > 150;
      if (n.children.length !== 1 && n !== el) break;
    }
    var b = getComputedStyle(document.body).backgroundColor.match(/[\d.]+/g);
    return b ? (+b[0] * .299 + +b[1] * .587 + +b[2] * .114) > 150 : false;
  }

  function Puff(o) {
    this.x = o.x; this.y = o.y; this.vx = o.vx || 0; this.vy = o.vy || -rand(.2, .6);
    this.size = o.size || rand(60, 140); this.grow = o.grow || rand(.25, .6);
    this.rot = rand(0, 6.28); this.vr = rand(-.006, .006);
    this.life = 0; this.max = o.max || rand(260, 460); this.alpha = o.alpha || rand(.35, .6);
    var set = o.dark ? SPR_DARK : SPR;
    this.img = o.gold ? SPR_GOLD : set[(Math.random() * set.length) | 0];
    this.wob = rand(0, 6.28); this.drag = o.drag || .995;
  }
  Puff.prototype.step = function (dt) {
    this.life += dt; this.wob += .012 * dt;
    this.vx *= Math.pow(this.drag, dt); this.vy *= Math.pow(this.drag, dt);
    this.x += (this.vx + Math.sin(this.wob) * .18) * dt; this.y += this.vy * dt;
    this.size += this.grow * dt; this.rot += this.vr * dt;
    return this.life < this.max;
  };
  Puff.prototype.draw = function (ctx) {
    var t = this.life / this.max, a = this.alpha * (t < .15 ? t / .15 : 1 - (t - .15) / .85);
    if (a <= 0) return;
    ctx.globalAlpha = a; ctx.save(); ctx.translate(this.x, this.y); ctx.rotate(this.rot);
    ctx.drawImage(this.img, -this.size / 2, -this.size / 2, this.size, this.size); ctx.restore();
  };

  /* ---------- A smoke field bound to one element ---------- */
  function SmokeField(host, opts) {
    this.host = host; this.opts = opts; this.p = []; this.run = false; this.vis = false;
    opts.dark = isLight(host); if (opts.dark) opts.strength = (opts.strength || 1) * .7;
    var c = this.c = document.createElement('canvas');
    c.className = 'ktd-fx-smoke' + (opts.under ? ' ktd-fx-smoke--under' : '');
    c.setAttribute('aria-hidden', 'true');
    host.classList.add('ktd-fx-smoke-host'); host.insertBefore(c, host.firstChild);
    this.ctx = c.getContext('2d'); this.resize();
    var self = this;
    this.ro = window.ResizeObserver ? new ResizeObserver(function () { self.resize(); }) : null;
    if (this.ro) this.ro.observe(host);
    new IntersectionObserver(function (e) { self.vis = e[0].isIntersecting; self.kick(); }).observe(host);
    for (var i = 0; i < this.target() * .7; i++) this.spawn(true);
    if (opts.interactive && finePointer) {
      var last = null;
      host.addEventListener('pointermove', function (e) {
        var r = self.c.getBoundingClientRect(), x = e.clientX - r.left, y = e.clientY - r.top;
        if (last) {
          var dx = x - last.x, dy = y - last.y, d = Math.hypot(dx, dy);
          if (d > 14) {
            self.p.push(new Puff({ x: x, y: y, vx: dx * .03, vy: dy * .03 - .25, size: rand(70, 120), grow: 1, max: rand(110, 180), alpha: .45, drag: .985, dark: self.opts.dark, gold: Math.random() < .2 }));
            last = { x: x, y: y };
          }
        } else last = { x: x, y: y };
      });
      host.addEventListener('pointerleave', function () { last = null; });
    }
  }
  SmokeField.prototype.target = function () { return Math.round((this.w / 1400) * (small ? 16 : 30) * (this.opts.density || 1)) + 6; };
  SmokeField.prototype.resize = function () {
    var r = this.host.getBoundingClientRect();
    this.w = Math.max(1, r.width); this.h = Math.max(1, r.height);
    this.c.width = this.w * DPR; this.c.height = this.h * DPR;
    this.ctx.setTransform(DPR, 0, 0, DPR, 0, 0);
  };
  SmokeField.prototype.spawn = function (anywhere) {
    var h = this.h;
    this.p.push(new Puff({
      x: rand(-60, this.w + 60),
      y: anywhere ? rand(h * .3, h + 40) : h + rand(20, 90),
      vx: rand(-.12, .12), vy: -rand(.18, .5) * (h / 600),
      size: rand(220, 420) * (small ? .7 : 1), grow: rand(.2, .5),
      max: rand(420, 700), alpha: rand(.35, .6) * (this.opts.strength || 1),
      dark: this.opts.dark, gold: Math.random() < (this.opts.gold || .12)
    }));
  };
  SmokeField.prototype.kick = function () {
    if (this.run || !this.vis || document.hidden) return;
    this.run = true; var self = this, prev = performance.now();
    function frame(now) {
      if (!self.vis || document.hidden) { self.run = false; return; }
      var dt = Math.min(3, (now - prev) / 16.7); prev = now;
      if (self.p.length < self.target() && Math.random() < .25 * dt) self.spawn(false);
      var ctx = self.ctx; ctx.clearRect(0, 0, self.w, self.h);
      self.p = self.p.filter(function (q) { var ok = q.step(dt); if (ok) q.draw(ctx); return ok; });
      ctx.globalAlpha = 1; requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);
  };
  document.addEventListener('visibilitychange', function () { fields.forEach(function (f) { f.kick(); }); });
  var fields = [];

  /* ---------- Full-screen overlay for bursts + cursor trail (idle when empty) ---------- */
  var ov, octx, ops = [], orun = false;
  function overlay() {
    if (ov) return;
    ov = document.createElement('canvas'); ov.className = 'ktd-fx-overlay'; ov.setAttribute('aria-hidden', 'true');
    document.body.appendChild(ov); octx = ov.getContext('2d'); osize();
    window.addEventListener('resize', osize);
  }
  function osize() { ov.width = innerWidth * DPR; ov.height = innerHeight * DPR; octx.setTransform(DPR, 0, 0, DPR, 0, 0); }
  function okick() {
    if (orun) return; orun = true; var prev = performance.now();
    function frame(now) {
      var dt = Math.min(3, (now - prev) / 16.7); prev = now;
      octx.clearRect(0, 0, innerWidth, innerHeight);
      ops = ops.filter(function (q) { var ok = q.step(dt); if (ok) q.draw(octx); return ok; });
      octx.globalAlpha = 1;
      if (ops.length) requestAnimationFrame(frame); else { orun = false; octx.clearRect(0, 0, innerWidth, innerHeight); }
    }
    requestAnimationFrame(frame);
  }
  function burst(x, y, n, big) {
    if (reduce) return; sprites(); overlay();
    for (var i = 0; i < n; i++) {
      var a = rand(0, 6.28), sp = rand(.6, big ? 3.2 : 1.8);
      ops.push(new Puff({ x: x, y: y, vx: Math.cos(a) * sp, vy: Math.sin(a) * sp - .6, size: rand(30, big ? 90 : 55), grow: rand(.5, 1.1), max: rand(70, 140), alpha: rand(.45, .75), drag: .965, gold: Math.random() < .35 }));
    }
    if (ops.length > 260) ops.splice(0, ops.length - 260);
    okick();
  }
  window.ktdSmokeBurst = burst;

  /* ---------- Scroll progress ---------- */
  function progress() {
    var bar = document.createElement('div'); bar.className = 'ktd-fx-progress'; document.body.appendChild(bar);
    var tick = false;
    function upd() { tick = false; var m = root.scrollHeight - innerHeight; bar.style.transform = 'scaleX(' + (m > 0 ? scrollY / m : 0) + ')'; }
    addEventListener('scroll', function () { if (!tick) { tick = true; requestAnimationFrame(upd); } }, { passive: true }); upd();
  }

  /* ---------- Scroll reveal ---------- */
  var REVEAL = '#MainContent .grid__item, #MainContent .title-wrapper-with-link, #MainContent .title-wrapper, #MainContent .collection-list-title, #MainContent .rich-text__blocks, #MainContent .multicolumn-card, #MainContent .product__info-wrapper';
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
  }, { rootMargin: '0px 0px -8% 0px', threshold: .08 }) : null;
  function reveal() {
    if (!io) return;
    var groups = new Map();
    document.querySelectorAll(REVEAL).forEach(function (el) {
      if (el.dataset.ktdRv || el.closest('quick-add-modal, .quick-add-modal, .ktd-fg, [role="dialog"]')) return;
      el.dataset.ktdRv = '1';
      var parent = el.parentElement, k = groups.get(parent) || 0; groups.set(parent, k + 1);
      el.style.setProperty('--fx-delay', Math.min(k, 8) * .06 + 's');
      el.classList.add('ktd-reveal');
      var t = el.querySelector('.title') || (el.classList.contains('title') ? el : null);
      if (t) t.classList.add('ktd-underline');
      io.observe(el);
    });
  }

  /* ---------- Hero heading condenses out of the smoke ---------- */
  function condense(h) {
    if (!h || h.dataset.ktdWords || h.children.length) return;
    var words = h.textContent.trim().split(/(\s+)/); h.dataset.ktdWords = '1';
    h.setAttribute('aria-label', h.textContent.trim()); h.textContent = '';
    var i = 0;
    words.forEach(function (w) {
      if (/^\s+$/.test(w)) { h.appendChild(document.createTextNode(' ')); return; }
      var s = document.createElement('span'); s.className = 'ktd-smoke-word'; s.setAttribute('aria-hidden', 'true');
      s.style.setProperty('--i', i++); s.textContent = w; h.appendChild(s);
    });
  }

  /* ---------- Homepage smoke ---------- */
  function homeSmoke() {
    sprites();
    var main = document.getElementById('MainContent'); if (!main) return;
    var secs = main.querySelectorAll(':scope > .shopify-section');
    var hero = main.querySelector('[id*="__slideshow"]') || main.querySelector('[id*="__image_banner"]') || secs[0];
    if (hero && !hero.querySelector('.ktd-fx-smoke')) {
      fields.push(new SmokeField(hero, { interactive: true, density: 1, strength: .7, gold: .14 }));
      hero.querySelectorAll('.banner__heading').forEach(condense);
    }
    // "under" smoke goes inside the section's coloured box so it sits above the background, behind the text
    function inner(sec) { return sec && (sec.querySelector(':scope > .rich-text, :scope > [class*="color-"], :scope > div') || sec); }
    var band = inner(main.querySelector('[id*="__order_form_banner"]'));
    if (band && !band.querySelector('.ktd-fx-smoke')) fields.push(new SmokeField(band, { under: true, interactive: true, density: .8, strength: .9, gold: .2 }));
    // gentle wisps behind the "Shop by brand" heading
    var brands = inner(main.querySelector('[id*="__brands_primary"]'));
    if (brands && !brands.querySelector('.ktd-fx-smoke')) fields.push(new SmokeField(brands, { under: true, density: .35, strength: .45, gold: .1 }));
  }

  /* ---------- Cursor vapour trail (homepage, desktop only) ---------- */
  function trail() {
    if (!finePointer) return;
    sprites(); overlay();
    var lx = null, ly = null, lt = 0;
    addEventListener('pointermove', function (e) {
      var now = performance.now();
      if (lx !== null && now - lt < 45) return;
      var dx = lx === null ? 0 : e.clientX - lx, dy = ly === null ? 0 : e.clientY - ly;
      lx = e.clientX; ly = e.clientY; lt = now;
      if (Math.abs(dx) + Math.abs(dy) < 6) return;
      ops.push(new Puff({ x: e.clientX, y: e.clientY, vx: dx * .01, vy: -.35, size: rand(18, 34), grow: .45, max: rand(60, 100), alpha: .32, drag: .98, gold: Math.random() < .3 }));
      okick();
    }, { passive: true });
  }

  /* ---------- Card hover puff ---------- */
  function cardPuffs() {
    if (!finePointer) return;
    document.addEventListener('pointerenter', function (e) {
      var c = e.target;
      if (!c.classList || !c.classList.contains('card-wrapper') || c.__ktdP && Date.now() - c.__ktdP < 900) return;
      c.__ktdP = Date.now();
      var r = c.getBoundingClientRect(); sprites(); overlay();
      for (var i = 0; i < 5; i++) ops.push(new Puff({ x: r.left + rand(r.width * .2, r.width * .8), y: r.top + rand(0, 16), vx: rand(-.3, .3), vy: -rand(.5, 1.1), size: rand(26, 50), grow: .55, max: rand(60, 100), alpha: .38, drag: .985, gold: Math.random() < .4 }));
      okick();
    }, true);
  }

  /* ---------- Add to cart: smoke burst + cart bounce ---------- */
  var ATC = 'button[name="add"], .quick-add__submit[type="submit"], form[action*="/cart/add"] button[type="submit"], .quick-order-list__button, .ktd-fg button[type="submit"]';
  function cartFx() {
    document.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest(ATC);
      if (!b || b.disabled) return;
      var r = b.getBoundingClientRect(); burst(r.left + r.width / 2, r.top + r.height / 2, 16, true);
    }, true);
    function bump() {
      var icon = document.getElementById('cart-icon-bubble'); if (!icon) return;
      icon.classList.remove('ktd-cart-bump'); void icon.offsetWidth; icon.classList.add('ktd-cart-bump');
      var r = icon.getBoundingClientRect(); burst(r.left + r.width / 2, r.top + r.height / 2, 10, false);
    }
    if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS) window.subscribe(PUB_SUB_EVENTS.cartUpdate, bump);
    else document.addEventListener('cart:updated', bump);
  }

  /* ---------- Button ripple ---------- */
  function ripples() {
    document.addEventListener('pointerdown', function (e) {
      var b = e.target.closest && e.target.closest('.button, .quick-add__submit, .shopify-payment-button__button');
      if (!b || b.disabled) return;
      var r = b.getBoundingClientRect(), d = Math.max(r.width, r.height) * 2.2, s = document.createElement('span');
      s.className = 'ktd-ripple'; s.style.cssText = 'width:' + d + 'px;height:' + d + 'px;left:' + (e.clientX - r.left) + 'px;top:' + (e.clientY - r.top) + 'px';
      b.appendChild(s); setTimeout(function () { s.remove(); }, 750);
    });
  }

  function init() {
    if (reduce) return; // CSS still shows everything; just no motion
    root.classList.add('ktd-fx');
    isHome = root.dataset.ktdTemplate === 'index';
    progress(); reveal(); ripples(); cartFx(); cardPuffs();
    if (isHome) { homeSmoke(); trail(); }
    var t; new MutationObserver(function () { clearTimeout(t); t = setTimeout(reveal, 250); })
      .observe(document.getElementById('MainContent') || document.body, { childList: true, subtree: true });
    document.addEventListener('shopify:section:load', function () { reveal(); if (isHome) homeSmoke(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
